import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoreComponent } from '../../core.component';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { BtCreateOrderResponseDto } from '../../../api/models/bt-create-order-response-dto';
import { OrdersService } from '../../../api/services/orders.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'rc-order-failed',
  templateUrl: './order-failed.component.html',
  styleUrls: ['./order-failed.component.scss'],
})
export class OrderFailedComponent extends CoreComponent {
  isRetryingPayment = false;
  errorMessage: string | null = null;

  constructor(private readonly route: ActivatedRoute, private readonly ordersService: OrdersService) {
    super();
  }

  get cartId(): string | null {
    return this.route.snapshot.queryParamMap.get('cartId');
  }

  get orderId(): string | null {
    return this.route.snapshot.queryParamMap.get('orderId');
  }

  get paymentOrderId(): string | null {
    return this.route.snapshot.queryParamMap.get('pcId');
  }

  retryPayment(): void {
    if (!this.orderId || !this.paymentOrderId || this.isRetryingPayment) {
      this.errorMessage = `A apărut o eroare neașteptată. Te rog să încerci din nou sau să ne contactezi la ${this.phone} pentru asistență.`;
      return;
    }

    this.isRetryingPayment = true;
    this.errorMessage = null; // Clear any previous error

    this.ordersService
      .ordersControllerGetPaymentUrlForFailedPayment({
        id: Number(this.orderId),
        paymentOrderId: this.paymentOrderId,
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error retrying payment:', error);

          if (error.status === 403) {
            this.errorMessage = `Ai incercat de prea multe ori sa reprocesezi plata. Te rog să ne contactezi la ${this.phone} pentru asistență.`;
          } else {
            this.errorMessage = `A apărut o eroare neașteptată. Te rog să încerci din nou sau să ne contactezi la ${this.phone} pentru asistență.`;
          }

          return of(null);
        }),
        finalize(() => {
          this.isRetryingPayment = false;
        }),
      )
      .subscribe((response: BtCreateOrderResponseDto | null) => {
        if (response?.formUrl) {
          // Redirect to the payment form URL
          window.location.href = response.formUrl;
        }
      });
  }
}
